import React, { Component } from "react";
import { connect } from "react-redux";

class WizardContent extends Component {
    render() {
        const { target, goNext, goPrev, onFinish, enableStep, disableStep } = this.props;

        if (target) {
            return React.cloneElement(target, { goNext, goPrev, onFinish, enableStep, disableStep });
        }
    }
}

export default connect()(WizardContent);
